import React, { useEffect } from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { IUser } from '../../../helpers/types';
import * as actions from '../../../actions';
// @ts-ignore ts-migrate(6142) FIXME: Module '../../ErrorBoundary' was resolved to '/Use... Remove this comment to see the full error message
import ErrorBoundary from '../../ErrorBoundary';

type OwnUnauthRouteProps = {
  component: any;
  user?: IUser;
  locale: string;
  logout: (...args: any[]) => any;
  emailUpdated?: boolean;
};

// @ts-ignore ts-migrate(2456) FIXME: Type alias 'UnauthRouteProps' circularly reference... Remove this comment to see the full error message
type UnauthRouteProps = OwnUnauthRouteProps & typeof UnauthRoute.defaultProps;

// @ts-ignore ts-migrate(7022) FIXME: 'UnauthRoute' implicitly has type 'any' because it... Remove this comment to see the full error message
const UnauthRoute = ({ component: Component, user, locale, logout, ...rest }: UnauthRouteProps) => {
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const emailToken = urlParams.get('emailToken');
  const securityToken = urlParams.get('security_token') || urlParams.get('securityToken');
  const signupToken = urlParams.get('signupToken');
  const id = urlParams.get('id');
  const token = urlParams.get('token');
  const renderComponent =
    !user ||
    !!emailToken ||
    (id && (token || (signupToken && securityToken)) && location.pathname.includes('/signup/confirm'));

  useEffect(() => {
    /**
     * If there is a security token in the search param in the signup/login page, it means that the user is an amazon user.
     * The logic is as follows.
     * 1. if (emailToken && !securityToken) - this is existing behavior where a non amazon user visiting a link which has email token is logged out and redireced to login page.
     * 2. (id && user && user.username !== id && !securityToken) - this is usual security check. If id in the url is not equal to logged in user then log him our and redirect to login page.
     * The reason adding !securityToken is to enable amazon user to transfer booking from one accoun to another. In this case the id in the url is different than the logged in user. Hence we should
     * not log out if user.username is not equal to id in the url IF amazon user.
     * (id && user && user.username !== id && securityToken && emailToken) - this means that amazon user is landing on sign up page. We need to make sure we log amazon user out if id in url doesn't match to user.id
     */
    if (
      (emailToken && !securityToken) ||
      (id && user && user.username !== id && !securityToken) ||
      (id && user && user.username !== id && securityToken && emailToken)
    ) {
      logout();
    }
  }, [logout, emailToken, id, user, securityToken]);

  return (
    // @ts-ignore ts-migrate(17004) FIXME: Cannot use JSX unless the '--jsx' flag is provided... Remove this comment to see the full error message
    <Route
      render={(props) =>
        renderComponent ? (
          // @ts-ignore ts-migrate(17004) FIXME: Cannot use JSX unless the '--jsx' flag is provided... Remove this comment to see the full error message
          <ErrorBoundary>
            {/* @ts-ignore ts-migrate(17004) FIXME: Cannot use JSX unless the '--jsx' flag is provided... Remove this comment to see the full error message */}
            <Component {...props} />
          </ErrorBoundary>
        ) : (
          // @ts-ignore ts-migrate(17004) FIXME: Cannot use JSX unless the '--jsx' flag is provided... Remove this comment to see the full error message
          <Redirect to={`/${locale}/account`} />
        )
      }
      {...rest}
    />
  );
};

UnauthRoute.defaultProps = {
  user: null,
  emailUpdated: false,
};

const mapStateToProps = ({ user, intl, customer }: any) => ({
  user: user.data,
  locale: intl.locale,
  emailUpdated: customer.emailUpdated,
});

const mapDispatchToProps = {
  logout: actions.logout,
};

export default connect(mapStateToProps, mapDispatchToProps)(UnauthRoute);
